<div class="flx-modal" role="dialog" aria-modal="true">
    <div class="flx-modal__header">
        <h2>{{translate?.jobOrder.label.singular}} {{translate?.setup.modules.templates.label.plural}}</h2>
        <button class="icon-btn" aria-label="Close" [pTooltip]="translate?.general.buttons.close.singular" (click)="modalRef.hide()">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>
    <div class="flx-modal__body"> 
        <div class="template-picker">
            <!-- Left panel: categories -->
            <aside class="tp-left" role="tablist" aria-label="Template categories">
                <div class="tp-left__list">
                    <button
                        *ngFor="let c of categories; trackBy: trackById"
                        type="button"
                        class="tp-cat"
                        role="tab"
                        [attr.aria-selected]="c.id === activeCatId"
                        [class.is-active]="c.id === activeCatId"
                        (click)="setCategory(c.id)"
                        >
                        <span class="tp-cat__label">{{ c.label }}</span>
                        <span class="tp-cat__count">{{ c.count }}</span>
                    </button>
                </div>

                <button type="button" class="tp-new-template" (click)="createNewTemplate()">
                    <i class="fa-regular fa-plus me-2"></i>
                    {{translate?.general.buttons.new.singular}} {{translate?.setup.modules.templates.label.singular}}
                </button>
            </aside>

            <!-- Right panel: search + list -->
            <section class="tp-right">
                <header class="tp-right__header">
                <h3>{{translate?.general.buttons.create.singular}} {{translate?.jobOrder.label.singular}} {{translate?.general.messages.fromLower}} {{translate?.setup.modules.templates.label.singular | lowercase}}</h3>
                <p>Pick {{translate?.general.messages.aLower}} {{translate?.setup.modules.templates.label.singular | lowercase}} to quickly {{translate?.general.buttons.create.singular}} {{translate?.general.messages.aLower}} {{translate?.jobOrder.label.singular}} with pre-filled details.</p>

                <span class="p-input-icon-left w-100 py-2">
                    <i class="pi pi-search"></i>
                    <input
                    type="text"
                    pInputText
                    [(ngModel)]="search"
                    placeholder="{{translate?.general.buttons.search.singular}} {{translate?.setup.modules.templates.label.plural | lowercase}}"
                    (keydown.enter)="$event.preventDefault()"
                    aria-label="Search templates"
                    />
                </span>
                </header>

                <div class="tp-list tp-list--grouped" role="listbox" [attr.aria-multiselectable]="false">
                <button
                    *ngFor="let t of filteredTemplates(); trackBy: trackById; let last = last"
                    type="button"
                    class="tp-row"
                    role="option"
                    [attr.aria-selected]="selectedTplId === t.id"
                    [class.is-selected]="selectedTplId === t.id"
                    [class.is-last]="last"
                    (click)="selectedTplId = t.id"
                >
                    <span class="icon" [style.--pill]="t.bg" [style.--pillIcon]="t.fg">
                    <i class="{{ t.icon }}"></i>
                    </span>

                    <div class="meta">
                    <div class="title">{{ t.title }}</div>
                    <div class="desc">{{ t.desc }}</div>
                    </div>

                    <span class="status-pill">{{ categoryLabel(t.categoryId) }}</span>
                </button>

                <div class="tp-empty" *ngIf="filteredTemplates().length === 0">
                    No {{translate?.setup.modules.templates.label.plural | lowercase}} found.
                </div>
                </div>

                 <div class="tp-right__footer">
                    <p-button type="button" [label]="translate?.general.buttons.next.singular" styleClass="action" (onClick)="nextCreate()"></p-button>
                </div>
            </section>
        </div>
    </div>
</div>